import { useLocation } from "react-router-dom";

export const useGetCurrentPathname = () => {
  const location = useLocation();
  return location.pathname;
};
